import script from "./PedidoVendaCadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./PedidoVendaCadastro.vue?vue&type=script&setup=true&lang=js"

import "./PedidoVendaCadastro.vue?vue&type=style&index=0&id=2aabab1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2aabab1a"]])

export default __exports__